var GenericEventType = /* @__PURE__ */ ((GenericEventType2) => {
  GenericEventType2["VACATION"] = "VACATION";
  GenericEventType2["ILLNESS"] = "ILLNESS";
  GenericEventType2["SCHOOL"] = "SCHOOL";
  GenericEventType2["PUBLIC_HOLIDAY"] = "PUBLIC_HOLIDAY";
  GenericEventType2["BLOCKER"] = "BLOCKER";
  GenericEventType2["OTHER"] = "OTHER";
  GenericEventType2["APPOINTMENT"] = "APPOINTMENT";
  return GenericEventType2;
})(GenericEventType || {});
var AppointmentErrorCode = /* @__PURE__ */ ((AppointmentErrorCode2) => {
  AppointmentErrorCode2["APPOINTMENT_INVALID_EMPLOYEE_TYPE_01"] = "APPOINTMENT_INVALID_EMPLOYEE_TYPE_01";
  AppointmentErrorCode2["APPOINTMENT_IN_THE_PAST"] = "APPOINTMENT_IN_THE_PAST";
  return AppointmentErrorCode2;
})(AppointmentErrorCode || {});
var InsuranceType = /* @__PURE__ */ ((InsuranceType2) => {
  InsuranceType2["PRIVATE_INSURANCE"] = "PRIVATE_INSURANCE";
  InsuranceType2["SOCIAL_INSURANCE"] = "SOCIAL_INSURANCE";
  InsuranceType2["ADDITIONAL_PRIVATE_INSURANCE"] = "ADDITIONAL_PRIVATE_INSURANCE";
  return InsuranceType2;
})(InsuranceType || {});
var GenderType = /* @__PURE__ */ ((GenderType2) => {
  GenderType2["FEMALE"] = "FEMALE";
  GenderType2["MALE"] = "MALE";
  GenderType2["DIVERSE"] = "DIVERSE";
  return GenderType2;
})(GenderType || {});
var AppointmentCancellation = /* @__PURE__ */ ((AppointmentCancellation2) => {
  AppointmentCancellation2["NO_SHOW"] = "NO_SHOW";
  AppointmentCancellation2["CANCELED_ON_TIME"] = "CANCELED_ON_TIME";
  AppointmentCancellation2["CANCELED_SHORT_TERM"] = "CANCELED_SHORT_TERM";
  AppointmentCancellation2["CANCELED"] = "CANCELED";
  AppointmentCancellation2["CANCELED_MOVED"] = "CANCELED_MOVED";
  AppointmentCancellation2["CANCELED_BY_PRACTICE"] = "CANCELED_BY_PRACTICE";
  return AppointmentCancellation2;
})(AppointmentCancellation || {});
var AppointmentState = /* @__PURE__ */ ((AppointmentState2) => {
  AppointmentState2["OPEN"] = "OPEN";
  AppointmentState2["WAITING"] = "WAITING";
  AppointmentState2["IN_TREATMENT_ROOM"] = "IN_TREATMENT_ROOM";
  AppointmentState2["IN_TREATMENT"] = "IN_TREATMENT";
  AppointmentState2["TREATED"] = "TREATED";
  AppointmentState2["CANCELED"] = "CANCELED";
  AppointmentState2["CONTROLLED"] = "CONTROLLED";
  AppointmentState2["DELETED"] = "DELETED";
  AppointmentState2["NO_SHOW"] = "NO_SHOW";
  return AppointmentState2;
})(AppointmentState || {});
var EmployeeRole = /* @__PURE__ */ ((EmployeeRole2) => {
  EmployeeRole2["NONE"] = "NONE";
  EmployeeRole2["ASSISTANT"] = "ASSISTANT";
  EmployeeRole2["ACCOUNTANT"] = "ACCOUNTANT";
  EmployeeRole2["HYGIENIST"] = "HYGIENIST";
  EmployeeRole2["DENTIST"] = "DENTIST";
  EmployeeRole2["DOCTOR"] = "DOCTOR";
  EmployeeRole2["CLINIC_MANAGER"] = "CLINIC_MANAGER";
  EmployeeRole2["RECEPTIONIST"] = "RECEPTIONIST";
  EmployeeRole2["DENTAL_TECHNICIAN"] = "DENTAL_TECHNICIAN";
  EmployeeRole2["TREATER"] = "TREATER";
  EmployeeRole2["NOT_SET"] = "NOT_SET";
  EmployeeRole2["NOT_MAPPED"] = "NOT_MAPPED";
  return EmployeeRole2;
})(EmployeeRole || {});
var EmployeeLevel = /* @__PURE__ */ ((EmployeeLevel2) => {
  EmployeeLevel2["CHIEF"] = "CHIEF";
  EmployeeLevel2["SENIOR"] = "SENIOR";
  EmployeeLevel2["JUNIOR"] = "JUNIOR";
  EmployeeLevel2["GRADUATE"] = "GRADUATE";
  return EmployeeLevel2;
})(EmployeeLevel || {});
var EmployeeStatus = /* @__PURE__ */ ((EmployeeStatus2) => {
  EmployeeStatus2["DISABLED"] = "DISABLED";
  EmployeeStatus2["INACTIVE"] = "INACTIVE";
  EmployeeStatus2["WILL_BE_ACTIVE"] = "WILL_BE_ACTIVE";
  EmployeeStatus2["ACTIVE"] = "ACTIVE";
  EmployeeStatus2["USED_TO_BE_ACTIVE"] = "USED_TO_BE_ACTIVE";
  EmployeeStatus2["UNKNOWN"] = "UNKNOWN";
  return EmployeeStatus2;
})(EmployeeStatus || {});
var SortingDirection = /* @__PURE__ */ ((SortingDirection2) => {
  SortingDirection2["ASC"] = "asc";
  SortingDirection2["DESC"] = "desc";
  return SortingDirection2;
})(SortingDirection || {});
var Language = /* @__PURE__ */ ((Language2) => {
  Language2["ENGLISH"] = "en";
  Language2["DEUTSCH"] = "de";
  return Language2;
})(Language || {});
var ServerSentResourceType = /* @__PURE__ */ ((ServerSentResourceType2) => {
  ServerSentResourceType2["ANAMNESIS"] = "ANAMNESIS";
  ServerSentResourceType2["APPOINTMENT"] = "APPOINTMENT";
  ServerSentResourceType2["CALL_TASK"] = "CALL_TASK";
  ServerSentResourceType2["TEXT_MESSAGE"] = "TEXT_MESSAGE";
  ServerSentResourceType2["CONVERSATION"] = "CONVERSATION";
  ServerSentResourceType2["TODO_LIST_TASK"] = "TODO_LIST_TASK";
  ServerSentResourceType2["PATIENT"] = "PATIENT";
  ServerSentResourceType2["OPEN_APPOINTMENT"] = "OPEN_APPOINTMENT";
  ServerSentResourceType2["PATIENT_CREDITWORTHINESS"] = "PATIENT_CREDITWORTHINESS";
  return ServerSentResourceType2;
})(ServerSentResourceType || {});
export {
  AppointmentCancellation,
  AppointmentErrorCode,
  AppointmentState,
  EmployeeLevel,
  EmployeeRole,
  EmployeeStatus,
  GenderType,
  GenericEventType,
  InsuranceType,
  Language,
  ServerSentResourceType,
  SortingDirection
};
